import { Phone } from 'lucide-react';
import { PHONE, PHONE_RAW } from '../constants/site';
import './PhoneCta.css';

const tel = PHONE_RAW.replace(/[^\d+]/g, '');

/** Phone CTA — homepage, search, support, and hooks sections. */
export default function PhoneCta({
  variant = 'banner',
  title,
  subtitle,
  badge,
  className = '',
}) {
  const rootClass = ['phone-cta', `phone-cta--${variant}`, className].filter(Boolean).join(' ');
  const isPromo = variant === 'promo';
  const badgeLabel =
    badge || (isPromo ? '24/7 live travel support' : 'Agents available now — no hold');

  return (
    <div className={rootClass} role="region" aria-label="Call us">
      {!isPromo && (
        <div className="phone-cta__icon-wrap" aria-hidden>
          <span className="phone-cta__icon-pulse" />
          <Phone size={22} strokeWidth={2.25} />
        </div>
      )}

      <div className="phone-cta__body">
        <span className="phone-cta__badge">
          <span className="phone-cta__badge-dot" aria-hidden />
          {badgeLabel}
        </span>
        {(title || subtitle) && (
          <div className="phone-cta__copy">
            {title && <p className="phone-cta__title">{title}</p>}
            {subtitle && <p className="phone-cta__subtitle">{subtitle}</p>}
          </div>
        )}
      </div>

      <div className="phone-cta__actions">
        <a href={`tel:${tel}`} className="phone-cta__btn phone-cta__btn--call">
          <span className="phone-cta__btn-ring" aria-hidden />
          <Phone size={20} strokeWidth={2.5} aria-hidden />
          <span className="phone-cta__btn-label">
            <small>Call 24/7 — free</small>
            <strong>{PHONE}</strong>
          </span>
        </a>
      </div>
    </div>
  );
}
